import logo1 from "../../images/logo1.png";
import logo2 from "../../images/logo2.png";
import logo3 from "../../images/logo3.png";
import logo4 from "../../images/logo4.png";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Autoplay } from "swiper/modules";

const HomeThirdSection = () => {
  return (
    <div className="pl-[40px] lg:pl-[125px] flex items-center justify-center gap-[30px] lg:gap-[90px] flex-wrap rounded-lg bg-[#e7e7e7] mx-[0px] md:mx-[50px] mt-[100px]">
      <Swiper
        slidesPerView={2}
        spaceBetween={10}
        loop={true}
        speed={800}
        autoplay={{
          disableOnInteraction: false,
        }}
        breakpoints={{
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 50,
          },
        }}
        modules={[Autoplay]}
        className="mySwiper transition-all duration-75 ease-in-out"
      >
        <SwiperSlide>
          <img src={logo1} className="h-[150px]" alt="" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={logo2} className="h-[150px]" alt="" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={logo3} className="h-[150px]" alt="" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={logo4} className="h-[150px]" alt="" />
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default HomeThirdSection;
